import { useContext, useMemo } from "react"
import { get as dig } from "lodash"
import { tokensByThemeSet } from "@planningcenter/doxy/ts"

import { bodyStyles } from "./doxyTokens/bodyStylesWithTokenThemeOverrides"
import { WebBootContext } from "./WebBoot"

export default function ThemeStyles({ mode }: { mode: "draft" | "published" }) {
  const webBootData = useContext(WebBootContext)

  const themingEnabled = dig(
    webBootData,
    `${mode}ThemeSettings.attributes.theme_enabled`,
  )
  const themeColor = dig(
    webBootData,
    `${mode}ThemeSettings.attributes.primary_color`,
  )
  const darkThemeColor = dig(
    webBootData,
    `${mode}ThemeSettings.attributes.dark_primary_color`,
  )

  const styles = useMemo(() => {
    if (!themingEnabled || !themeColor) return null

    return bodyStyles({
      overrides: [
        {
          themeableTokens: tokensByThemeSet.brand,
          newLightValue: themeColor,
          newDarkValue: darkThemeColor || themeColor,
        },
      ],
      brandLight: themeColor,
      brandDark: darkThemeColor || themeColor,
    })
  }, [themingEnabled, themeColor, darkThemeColor])

  return styles && <style>{styles}</style>
}
